<template>
  <div class="date" :class="[{ 'my-2': !compact }, !isDarkThemeEnabled ? 'gray-600' : '']">
    <i v-if="showIcon" class="fa fa-clock mr-1"></i>{{ stampDate }}
  </div>
</template>

<script>
  import { addDays, format, formatDistanceToNow, isPast, parseISO } from 'date-fns';
  import { mapGetters } from 'vuex';

  export default {
    name: 'DateTimeStamp',

    props: {
      pastFormat: { type: String, default: 'dd-MMM-yyyy HH:mm' },
      showIcon: { type: Boolean, default: true },
      dateOnly: Boolean,
      compact: Boolean,
      date: String,
      showRelative: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      ...mapGetters(['isDarkThemeEnabled']),

      now() {
        //current date-time
        return new Date();
      },

      parsedDate() {
        return parseISO(this.date);
      },

      aWeekFromDate() {
        //a week from date
        return addDays(this.parsedDate, 7);
      },

      isDatePast() {
        return isPast(this.aWeekFromDate);
      },

      stampDate() {
        if (this.dateOnly) {
          return format(this.parsedDate, 'dd-MMM-yyyy', { weekStartsOn: 1 });
        }
        if (this.isDatePast == true || !this.showRelative) {
          /*CHECK: is '== true' the best check?*/
          return format(this.parsedDate, this.pastFormat, { weekStartsOn: 1 });
        }
        return formatDistanceToNow(this.parsedDate, { includeSeconds: true }) + ' ago';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/config/variables';
  @import '~bootstrap/scss/mixins/breakpoints';

  .now {
    color: cadetblue;
  }

  .date {
    display: inline;
  }

  .date,
  .date fa {
    font-size: 0.75rem;
    font-weight: 600;
  }

  .reply-date {
    margin-top: 1rem;
    margin-left: calc(35px + 1rem);
    display: block;
  }

  @include media-breakpoint-down(md) {
    .reply-date {
      margin: 0 !important;
      position: absolute;
      top: 0;
      right: 1rem;
    }
  }
</style>
